import api from './api';

export async function listAllSectors() {
    return api.get(`sector/list`);
}

export async function listSectorsByEvent(id) {
    return api.get(`sector/event/${id}`);
}

export async function createSectors(payload) {
    console.log("SectorService -> create -> payload", payload);
    return api.post(`sector`, payload);
}

export async function deleteSectorsByEvent(id) {
    console.log("SectorService -> destroy -> event id", id);
    return api.delete(`sector/event/${id}`);
}

export async function deleteSectorsById(id) {
    console.log("SectorService -> destroy -> sector_id", id);
    return api.delete(`sector/event/sector/${id}`);
}

export async function updateSectorsByEvent(id, payload) {
    console.log("SectorService -> update -> payload", payload);
    console.log("SectorService -> update -> event id", id);
    return api.patch(`sector/event/${id}/update`, payload)
}

export async function updateSectorById(id, payload) {
    console.log("SectorService -> update -> payload", payload);
    console.log("SectorService -> update -> sector id", id);
    return api.patch(`sector/${id}/update`, payload)
}

export async function updateSectorsByEventNoKey(id, payload) {
    console.log("SectorService -> updateNoKey -> payload", payload);
    console.log("SectorService -> updateNoKey -> sector id", id);
    return api.patch(`sector/event/${id}/updateNoKey`, payload)
}